export default __webpack_public_path__ + "static/media/plus.e065c242.svg";